export const css = {
	statusIcon: '_1DuQEf-b',
	badgeStatusIcon: '_1DhBPThe',
	statusNotDone: '_2zZ70OwN',
	statusComplete: '_3I-DrcTA',
	statusInProgress: 'EzmR2G3J',
	' _key': 'certwise-theme/certwise/book-widgets/status-icon'
};

export default css;
